// src/pages/LandingPage.jsx
import React from 'react';
import Footer from '../components/Footer';

function LandingPage() {
  return (
    <div className="landing-page">
      <nav className="navbar navbar-expand-lg bg-white border-bottom">
  <div className="container py-2">

    <div className="d-flex align-items-center gap-2">
      <img src="/logo.png" alt="EduSpace Logo" style={{ height: "36px" }} />
      <span className="fw-bold" style={{ fontSize: "1.1rem" }}>
        EduLinker
      </span>
    </div>

    <div className="d-flex gap-2">
      <a href="/get-started" className="btn btn-outline-dark btn-sm rounded-3">
        Get Started
      </a>
      <a href="/login" className="btn btn-dark btn-sm rounded-3">
        Login
      </a>
    </div>

  </div>
</nav>
<div className="container py-5 mt-4">

  <div className="row align-items-center">

    {/* LEFT */}
    <div className="col-lg-6 mb-4">

      <h1 className="fw-bold mb-3" style={{ fontSize: "2.4rem" }}>
        Get instant help from
        <span style={{ color: "#4f46e5" }}> verified teachers</span>
      </h1>

      <p className="text-muted mb-4" style={{ maxWidth: "500px" }}>
        Request help, schedule sessions, hire teacher and improve your learning faster — all in one platform built for students, educators and parents.
      </p>

      {/* CTA */}
      <div className="d-flex gap-2 flex-wrap mb-4">

  <a href="/teachers" className="btn btn-dark px-4 rounded-3">
    Find a Teacher
  </a>

  <a href="/how-it-works" className="btn btn-outline-secondary px-4 rounded-3">
    How it works
  </a>

</div>

      {/* TRUST SIGNALS */}
      <div className="d-flex gap-3 flex-wrap small text-muted">

        <span>✔ Verified Teachers</span>
        <span>✔ Instant Help</span>
        <span>✔ Secure Payments</span>

      </div>

    </div>

    {/* RIGHT */}
    <div 
  className="rounded-4 p-3 mx-auto"
  style={{
    background: "#f8fafc",
    border: "1px solid #e5e7eb",
    maxWidth: "500px"
  }}
>

  <img 
    src="/hero.jpg" 
    alt="EduLinker Dashboard"
    className="img-fluid rounded-3"
    style={{
      maxHeight: "320px",
      objectFit: "cover"
    }}
  />

</div>

  </div>

</div>
      <main className="main-content py-5">
        <div className="container">
          <div className="row g-4 mt-2">
            {/* First Card - AI Recommendation */}
            <div className="col-md-4">
  <div className="card h-100 border-0 shadow-sm rounded-4">
    <div className="card-body d-flex flex-column justify-content-between">
      <div>
        <div
          className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mb-3"
          style={{
            width: "70px",
            height: "70px",
            background: "#eef2ff"
          }}
        >
          <i className="fas fa-robot fa-2x text-primary"></i>
        </div>

        <h5 className="fw-bold text-dark mb-2">
          AI Student Teacher Recommendation
        </h5>

        <small className="text-muted d-block">
          Experience the future of education with our AI-powered student
          recommendations, designed to enhance learning outcomes for every
          student.
        </small>
      </div>

      <div className="mt-4">
        <a href="/login" className="btn btn-primary">
          Try Now
        </a>
      </div>
    </div>
  </div>
</div>
            {/* Second Card - Image Card */}
            <div className="col-md-4">
              <div className="card h-100 shadow border-0 overflow-hidden">
                <div className="card-img-top" style={{height: '200px', overflow: 'hidden'}}>
  <img 
    src="/kid_pic.jpg" 
    alt="Interactive Learning" 
    className="img-fluid w-100 h-100 object-fit-cover"
  />
</div>
                <div className="card-body d-flex flex-column">
                  <h5 className="fw-bold text-dark">Interactive Learning Hub</h5>
                  <small className="text-muted">
                   Experience seamless support with our Instant Get Help feature, 
                   connecting students to available teachers online for immediate assistance.
                  </small>
                  <div className="mt-auto pt-3">
                    <div className="d-flex align-items-center mb-2">
                      <i className="fas fa-video text-primary me-2"></i>
                      <span>Live learning session </span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <i className="fas fa-book text-primary me-2"></i>
                      <span>Edu coin reward learning system</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <i className="fas fa-users text-primary me-2"></i>
                      <span>Download exams past question and answer</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Third Card - Girls for Tech */}
            <div className="col-md-4">
              <div className="card h-100 shadow border-0">
                <div className="card-body d-flex flex-column">
                  <div className="mb-3">
                    <div className="bg-pink bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mb-3" 
                         style={{ background: "#eef2ff" }}>
                      <i className="fas fa-female fa-2x" style={{color: '#ec4899'}}></i>
                    </div>
                    <h5 className="fw-bold text-dark">Girls for Tech Curriculum</h5>
                    <small className="text-muted">
                      <strong className="text-primary">Access, teach, and download the Girls for Tech Curriculum-empowering 
                        girls, one lesson at a time.</strong>
                    </small>
                    <p className="card-text text-muted">
                      Building the next generation of female tech leaders.
                      A comprehensive curriculum designed for girls aged 10–21.
                    </p>
                  </div>
                  
                  <div className="mb-4">
                    <h6 className="fw-bold mb-2">Program Features:</h6>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-success me-2"></i>
                        Complete coding curriculum
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-success me-2"></i>
                        Teacher training materials
                      </li>
                      <li className="mb-2">
                        <i className="fas fa-check-circle text-success me-2"></i>
                        Hands-on projects & activities
                      </li>
                      <li>
                        <i className="fas fa-check-circle text-success me-2"></i>
                        Certification program
                      </li>
                    </ul>
                  </div>
                  
                  <div className="mt-auto">
                    <div className="d-grid gap-2">
                      <a href="/girls-for-tech" className="btn btn-success">
                        <i className="fas fa-book-open me-2"></i> Access Curriculum
                      </a>
                      <a href="/training" className="btn btn-outline-primary">
                        <i className="fas fa-chalkboard-teacher me-2"></i> Teacher Training
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Call to Action Section */}
          <div className="mt-5 pt-5">

  <div 
    className="rounded-4 p-5 text-center text-white"
    style={{ background: "#0f172a" }}
  >

    <h3 className="fw-bold mb-3">
      Ready to Transform Education?
    </h3>

    <p className="opacity-75 mb-4">
      Join educators and students using EduLinker to improve learning outcomes.
    </p>

    <div className="d-flex justify-content-center gap-3 flex-wrap">

      <a href="/get-started" className="btn btn-light rounded-3 px-4">
        Get Started Free
      </a>

      <a href="/demo" className="btn btn-outline-light rounded-3 px-4">
        Book Demo
      </a>

    </div>

  </div>

</div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default LandingPage;